module.exports = __webpack_public_path__ + "static/species360-141b91c30a952792a3aa2912d98c41d7.jpeg";